import React from 'react';

const FileIcon = () => {
  return (
    <div className="vbz-icon-beneficiaries">
      <div className="vbz-icon-beneficiaries-file" />
    </div>
  );
};

export default FileIcon;
